<template>
    <main>
        <agile :navButtons=false>
            <img class="slide" src="http://www.shengjia-resin.com/temp/1.jpg" />
            <img class="slide" src="http://www.shengjia-resin.com/temp/2.jpg" />
            <img class="slide" src="http://www.shengjia-resin.com/temp/3.jpg" />
        </agile>
        <div class="article-wrapper">
            <article class="text-body">
                <div class="img-style" v-html="content"></div>
            </article>
        </div>
    </main>
</template>

<script>
    import qs from 'qs';
    import {
        VueAgile
    } from 'vue-agile'
    export default {
        name: 'Honor',
        components: {
            agile: VueAgile
        },
        data() {
            return {
                content: '',
                datas: {},
                type: '荣誉证书',
            }
        },
        mounted() {
            this.loadData();
        },
        methods: {
            loadData() {
                this.$axios.post('/findCompanyByType', qs.stringify({companyType:this.type})).then(res => {
                    this.datas = res.data;
                    if (this.datas != null) {
                        this.content = this.datas.content;
                    }
                }).catch(res => {
                    alert("数据获取失败")
                })
            }
        }
    }
</script>

<style lang="less">
    .honor-list {
        margin: 0;
        padding: 0;
        display: flex;
        flex-wrap: wrap;

        &-item {
            list-style-type: none;
            overflow: hidden;
            box-sizing: border-box;
            width: 50%;
            padding: 16px 32px;
            overflow: hidden;
            height: 450px;
            text-align: center;

            >img {
                width: 100%;
            }

            p {
                margin: 0;
                text-indent: 0;
            }
        }
    }


    .text-body {
        width: 1200px;
        max-width: 1200px;
        overflow: auto;
    }

    .img-style p {
        width: 550px;
        margin: 15px 15px;
        float: left;
    }

    .img-style img {
         width: 550px;
        height: 420px;
        min-width: 550px;
        min-height: 420px;
    }
</style>